import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route';
import {
	CONTAINER_HOME_ID,
	COMPANY_HUB_SETTINGS_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils';
import { ContentHistoryLoader } from '@confluence/content-history';
import { getCompanyHubPseudoAppRoute } from '@confluence/ssr-app/entry-points/getCompanyHubPseudoAppRoute';
import { expValEquals } from '@confluence/feature-experiments';
import { NewContentHistory } from '@confluence/content-history-new';
import { ClassicEditorContextProviderLoader } from '@confluence-classic/confluence-fabric-editor/src/components/ClassicEditorContextProvider';

const ContentHistoryRouteComponent = ({ params: { spaceKey, contentId } }: RouteMatch) =>
	expValEquals('confluence_content_history_updates', 'isEnabled', true) ? (
		<ClassicEditorContextProviderLoader>
			<NewContentHistory
				contentId={contentId}
				spaceKey={spaceKey}
				ClassicEditorContextProviderLoader={ClassicEditorContextProviderLoader}
			/>
		</ClassicEditorContextProviderLoader>
	) : (
		<ContentHistoryLoader spaceKey={spaceKey} contentId={contentId} stack="classic" />
	);

ContentHistoryRouteComponent.NAVIGATION_PARAMS = ({
	params: { spaceKey, contentId, contentSlug },
}: RouteMatch) => {
	const isCompanyHub = isCompanyHubSpaceKey(spaceKey);

	return {
		Screen: {
			screenEvent: {
				name: isCompanyHub ? 'hubHistoryScreen' : 'pageHistoryScreen',
				id: contentId,
			},
			pageState: {
				spaceKey,
				contentId,
				contentSlug,
			},
		},
		MainLayout: {
			spaceKey,
			navView: isCompanyHub ? COMPANY_HUB_SETTINGS_ID : CONTAINER_HOME_ID,
		},
	};
};

export const ContentHistoryRoute = getCompanyHubPseudoAppRoute(
	ContentHistoryRouteComponent,
	(route: RouteMatch) => isCompanyHubSpaceKey(route?.params?.spaceKey),
);
